import SectionBox from "../components/SectionBox";
import { Helmet } from "react-helmet";
import Glowing3DCarousel from "../components/ThreeDSlider";
import GlobalBackground from "../components/GlobalBackground";
import RunningText from "../components/RunningText";
export default function About() {
    return (
        <GlobalBackground>

            <Helmet>
                <meta name="robots" content="noindex, follow" />
            </Helmet>

            <main>
                {/* ⭐ 3D CAROUSEL */}
                <Glowing3DCarousel />

                <SectionBox className="mt-24">
                    <div className="flex justify-center">
                        <div className="w-full max-w-6xl rounded-3xl overflow-hidden shadow-2xl bg-black/60">

                            <div className="grid md:grid-cols-2 items-stretch">

                                {/* LEFT – IMAGE */}
                                <div className="h-full">
                                    <img
                                        src="/images/about/1.jpg"
                                        alt="Balaji Masale"
                                        className="w-full h-full object-cover"
                                    />
                                </div>

                                {/* RIGHT – TEXT */}
                                <div className="flex items-center px-6 md:px-12 py-12">
                                    <div>
                                        <h2 className="text-3xl md:text-5xl font-bold text-[#ffb3b8]">
                                            श्री बालाजी मसाले के बारे में
                                        </h2>

                                        <p className="mt-6 text-gray-100 leading-relaxed text-lg">
                                            श्री बालाजी मसाले एक विश्वसनीय और प्रतिष्ठित भारतीय मसाला ब्रांड है,
                                            जिसकी स्थापना वर्ष <strong>2001</strong> में की गई थी।
                                            <br /><br />
                                            हमारा उद्देश्य हर रसोई तक शुद्ध, स्वच्छ और स्वादिष्ट
                                            मसाले पहुँचाना है।
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <Helmet>
                        <meta name="robots" content="noindex, follow" />
                    </Helmet>
                </SectionBox>


                <SectionBox className="mt-14">
                    <div className="flex justify-center">
                        <div className="
      w-full
      max-w-6xl
      bg-black/55
      backdrop-blur-sm
      rounded-3xl
      p-6 md:p-10
    ">
                            <div className="grid md:grid-cols-2 gap-10 items-center">

                                {/* IMAGE */}
                                <div className="flex justify-center">
                                    <img
                                        src="/images/about/company.png"
                                        alt="Balaji Masale Shop"
                                        className="w-full max-w-md rounded-2xl shadow-lg object-cover"
                                    />
                                </div>

                                {/* CONTENT */}
                                <div>
                                    <h2 className="text-3xl md:text-4xl font-bold text-[#ffb3b8]">
                                        हमारी पहचान
                                    </h2>

                                    <ul className="mt-6 space-y-4 text-gray-200 text-lg">
                                        <li>📍 <strong>पता:</strong> कुरावर, ज़िला राजगढ़, मध्य प्रदेश</li>
                                        <li>🏭 <strong>स्थापना वर्ष:</strong> 2001</li>
                                        <li>👤 <strong>संस्थापक / मालिक:</strong> श्री हरिओम जी शर्मा</li>
                                        <li>🌍 <strong>कार्यक्षेत्र:</strong> मध्य प्रदेश सहित 15+ जिलों में आपूर्ति</li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </SectionBox>



                <section className="py-14">
                    <div className="max-w-6xl mx-auto px-6">

                        {/* CENTERED BOX */}
                        <div className="
      bg-black/55
      backdrop-blur-sm
      rounded-3xl
      shadow-2xl
      p-8 md:p-12
    ">
                            <div className="grid md:grid-cols-2 gap-10 items-center">

                                {/* OWNER PHOTO */}
                                <div className="flex justify-center">
                                    <img
                                        src="/images/about/owner.jpg"
                                        alt="Shri Hariom Ji Sharma"
                                        className="
              w-56 h-56
              md:w-64 md:h-64
              object-cover
              rounded-2xl
              shadow-lg
              ring-4 ring-white/10
            "
                                    />
                                </div>

                                {/* OWNER MESSAGE */}
                                <div>
                                    <h2 className="text-3xl md:text-4xl font-bold text-[#ffb3b8] mb-5">
                                        Founder’s Message
                                    </h2>

                                    <p className="text-gray-200 leading-relaxed text-lg">
                                        श्री बालाजी मसाले की स्थापना <strong>2001</strong> में
                                        शुद्ध एवं गुणवत्तापूर्ण मसालों की आपूर्ति के उद्देश्य से की गई थी।
                                        <br /><br />
                                        हम चयनित कच्चे माल,
                                        स्वच्छ उत्पादन प्रक्रिया और
                                        <strong> FSSAI मानकों</strong> के अनुसार निर्मित उत्पादों पर
                                        विशेष ध्यान देते हैं।
                                        <br /><br />
                                        ग्राहकों का विश्वास और
                                        समान गुणवत्ता बनाए रखना
                                        हमारी कार्यप्रणाली का आधार है।
                                    </p>

                                    <p className="mt-6 font-semibold text-[#ffb3b8]">
                                        — श्री हरिओम जी शर्मा
                                    </p>
                                    <p className="text-sm text-gray-400">
                                        संस्थापक एवं मालिक, श्री बालाजी मसाले
                                    </p>
                                </div>

                            </div>
                        </div>

                    </div>
                </section>


                <section className="py-14">
                    <div className="max-w-6xl mx-auto px-6">

                        <SectionBox>
                            <div
                                className="
          bg-black/55
          backdrop-blur-sm
          rounded-3xl
          shadow-2xl
          p-8 md:p-12
        "
                            >
                                <div className="grid md:grid-cols-2 gap-10 items-center">

                                    {/* LEFT IMAGE */}
                                    <div className="flex justify-center">
                                        <img
                                            src="/images/about/fssai.jpg"
                                            alt="FSSAI Certification"
                                            className="
                w-full
                max-w-sm
                h-64 md:h-72
                rounded-2xl
                shadow-lg
                object-contain
                bg-white
                p-6
              "
                                        />
                                    </div>

                                    {/* RIGHT CONTENT */}
                                    <div>
                                        <h2 className="text-3xl md:text-4xl font-bold text-[#ffb3b8]">
                                            गुणवत्ता एवं प्रमाणन
                                        </h2>

                                        <p className="mt-5 text-gray-200 leading-relaxed text-lg">
                                            श्री बालाजी मसाले को वर्ष <strong>2014</strong> में
                                            <strong> FSSAI (भारतीय खाद्य सुरक्षा एवं मानक प्राधिकरण)</strong> से
                                            मान्यता प्राप्त हुई।
                                            <br /><br />
                                            हमारे प्रमुख उत्पादों में
                                            <strong> हल्दी, मिर्च, धनिया और मिक्स मसाला</strong> शामिल हैं,
                                            जिन्हें उच्च गुणवत्ता मानकों के अनुसार तैयार किया जाता है।
                                        </p>

                                        {/* FSSAI NUMBER */}
                                        <div className="mt-6 inline-block bg-green-500/10 border border-green-500/30 rounded-xl px-6 py-4">
                                            <p className="text-sm text-gray-300">FSSAI लाइसेंस नंबर</p>
                                            <p className="text-xl font-bold text-green-400 tracking-wider">
                                                1142307000213
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </SectionBox>

                    </div>
                </section>

                <RunningText />

                {/* ================= VISION & MISSION – GLASS STYLE ================= */}
                <section className="py-10 md:py-14">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6">

                        {/* OUTER GLASS BOX */}
                        <div className="
            bg-black/60
            backdrop-blur-md
            rounded-2xl md:rounded-3xl
            shadow-2xl
            p-6 sm:p-8 md:p-14
        ">

                            {/* Heading */}
                            <div className="text-center mb-10 md:mb-14">
                                <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-[#ffb3b8] leading-snug">
                                    हमारा विज़न <span className="hidden sm:inline">•</span><br className="sm:hidden" />
                                    मिशन <span className="hidden sm:inline">•</span><br className="sm:hidden" />
                                    मूल्य
                                </h2>

                                <p className="mt-4 text-gray-200 text-sm sm:text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
                                    शुद्धता, गुणवत्ता और विश्वास के साथ
                                    हर भारतीय रसोई तक असली स्वाद।
                                </p>
                            </div>

                            {/* Cards */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">

                                {/* Vision */}
                                <div className="bg-white/95 rounded-2xl md:rounded-3xl shadow-lg p-6 md:p-8 text-center hover:-translate-y-1 transition duration-300">
                                    <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-[#7a0c18]/10 flex items-center justify-center">
                                        <span className="text-2xl md:text-3xl">🌟</span>
                                    </div>
                                    <h3 className="text-xl md:text-2xl font-bold text-[#7a0c18] mb-3">
                                        हमारा विज़न
                                    </h3>
                                    <p className="text-gray-700 leading-relaxed text-sm md:text-lg">
                                        श्री बालाजी मसाले को भारत के हर घर में
                                        शुद्ध, सुरक्षित और भरोसेमंद मसालों का
                                        पहला नाम बनाना।
                                    </p>
                                </div>

                                {/* Mission */}
                                <div className="bg-white/95 rounded-2xl md:rounded-3xl shadow-lg p-6 md:p-8 text-center hover:-translate-y-1 transition duration-300">
                                    <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-[#7a0c18]/10 flex items-center justify-center">
                                        <span className="text-2xl md:text-3xl">🎯</span>
                                    </div>
                                    <h3 className="text-xl md:text-2xl font-bold text-[#7a0c18] mb-3">
                                        हमारा मिशन
                                    </h3>
                                    <p className="text-gray-700 leading-relaxed text-sm md:text-lg">
                                        चुनिंदा कच्चे मसालों, स्वच्छ निर्माण
                                        प्रक्रिया और समान गुणवत्ता के साथ
                                        हर पैक में असली स्वाद पहुँचाना।
                                    </p>
                                </div>

                                {/* Values */}
                                <div className="bg-white/95 rounded-2xl md:rounded-3xl shadow-lg p-6 md:p-8 text-center hover:-translate-y-1 transition duration-300">
                                    <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-[#7a0c18]/10 flex items-center justify-center">
                                        <span className="text-2xl md:text-3xl">🤝</span>
                                    </div>
                                    <h3 className="text-xl md:text-2xl font-bold text-[#7a0c18] mb-3">
                                        हमारे मूल्य
                                    </h3>
                                    <p className="text-gray-700 leading-relaxed text-sm md:text-lg">
                                        ईमानदारी, गुणवत्ता, पारदर्शिता और
                                        ग्राहकों के विश्वास को
                                        हमेशा सबसे ऊपर रखना।
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>


                {/* ================= MARKET COVERAGE – GLASS STYLE ================= */}
                <section className="py-14">
                    <div className="max-w-7xl mx-auto px-6">

                        {/* OUTER GLASS BOX */}
                        <div
                            className="
        bg-black/55
        backdrop-blur-sm
        rounded-3xl
        shadow-2xl
        p-8 md:p-14
      "
                        >
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

                                {/* LEFT – TEXT */}
                                <div>
                                    <h2 className="text-3xl md:text-4xl font-bold text-[#ffb3b8]">
                                        हमारा विस्तार
                                    </h2>

                                    <p className="mt-6 text-gray-200 leading-relaxed text-lg">
                                        श्री बालाजी मसाले आज <strong>मध्य प्रदेश के 15+ जिलों</strong> में
                                        सफलतापूर्वक उपलब्ध है और निरंतर विस्तार की दिशा में आगे बढ़ रहा है।
                                        <br /><br />
                                        ग्राहकों का भरोसा, गुणवत्ता की निरंतरता और
                                        असली भारतीय स्वाद हमारे विकास और विस्तार
                                        का सबसे बड़ा कारण है।
                                    </p>
                                </div>

                                {/* RIGHT – IMAGE */}
                                <div className="relative flex justify-center">
                                    <img
                                        src="/images/mp.png"
                                        alt="Balaji Masale Market Coverage"
                                        className="
              w-full
              max-w-md
              rounded-2xl
              shadow-xl
            "
                                    />


                                </div>

                            </div>
                        </div>
                    </div>
                </section>


                {/* ================= TRUST POINTS – BOXED ================= */}
                <section className="py-12">
                    <div className="max-w-6xl mx-auto px-6">

                        {/* OUTER BOX */}
                        <div className="bg-[#fff8f0] rounded-3xl shadow-2xl p-8 md:p-14">

                            {/* Heading */}
                            <h2 className="text-3xl md:text-4xl font-extrabold text-[#7a0c18] text-center mb-12">
                                श्री बालाजी मसाले पर क्यों भरोसा करें
                            </h2>

                            {/* Cards */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                <div className="bg-white rounded-2xl shadow-md p-6 flex items-center gap-4">
                                    <span className="text-[#7a0c18] text-2xl">✔</span>
                                    <p className="text-lg text-gray-800">
                                        2009 से निरंतर गुणवत्ता
                                    </p>
                                </div>

                                <div className="bg-white rounded-2xl shadow-md p-6 flex items-center gap-4">
                                    <span className="text-[#7a0c18] text-2xl">✔</span>
                                    <p className="text-lg text-gray-800">
                                        FSSAI प्रमाणित उत्पाद
                                    </p>
                                </div>

                                <div className="bg-white rounded-2xl shadow-md p-6 flex items-center gap-4">
                                    <span className="text-[#7a0c18] text-2xl">✔</span>
                                    <p className="text-lg text-gray-800">
                                        शुद्ध एवं चयनित कच्चा माल
                                    </p>
                                </div>

                                <div className="bg-white rounded-2xl shadow-md p-6 flex items-center gap-4">
                                    <span className="text-[#7a0c18] text-2xl">✔</span>
                                    <p className="text-lg text-gray-800">
                                        स्वच्छ और आधुनिक निर्माण प्रक्रिया
                                    </p>
                                </div>

                                {/* FULL WIDTH POINT */}
                                <div className="bg-white rounded-2xl shadow-md p-6 flex items-center gap-4 md:col-span-2 justify-center">
                                    <span className="text-[#7a0c18] text-2xl">✔</span>
                                    <p className="text-lg text-gray-800 text-center">
                                        मध्य प्रदेश के 15+ जिलों में विस्तार
                                    </p>
                                </div>

                            </div>

                        </div>
                    </div>
                </section>


            </main>
        </GlobalBackground>
    );
}
